import React from "react";
import styles from "./LogoWrapper.module.css";

const LogoWrapper = ({ src, class_ }) => {

	return (
		<div className={`${styles.logo_wrapper} ${class_}`}>
            <img src={src} className={styles.logo} alt="Logo" />
        </div>
	);
};

export default LogoWrapper;

